import hardware from "./hardware"

export default {
  hardware,
}
